
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/annual-returns",
      function () {
        return require("private-next-pages/annual-returns/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/annual-returns"])
      });
    }
  